import IModelerNode from '@Shared.Angular/@types/modelerNode';
import { NodeCategory } from '@Shared.Angular/flowingly.services/flowingly.constants';
import { IModelerNodeLink } from '@Shared.Angular/@types/workflow';

const nonConnectorNodeCategories = new Set([
  NodeCategory.POOL,
  NodeCategory.LANE
]);

export function getUnreachableNodeKeys(
  nodes: IModelerNode[],
  links: IModelerNodeLink[]
): number[] {
  const workflowNodes = nodes.filter(
    (node) => !nonConnectorNodeCategories.has(node.category)
  );
  const workflowNodeKeys = new Set(workflowNodes.map((node) => node.key));
  const startNode = workflowNodes.find((node) => node.IsInitial === 'true');

  if (!startNode) {
    return [];
  }

  const outgoingLinks = new Map<number, number[]>();
  links.forEach((link) => {
    if (
      link.isBacklink ||
      !workflowNodeKeys.has(link.from) ||
      !workflowNodeKeys.has(link.to)
    ) {
      return;
    }

    const targets = outgoingLinks.get(link.from) || [];
    targets.push(link.to);
    outgoingLinks.set(link.from, targets);
  });

  const reachableNodeKeys = new Set<number>();
  const nodesToVisit = [startNode.key];

  while (nodesToVisit.length > 0) {
    const nodeKey = nodesToVisit.pop();

    if (reachableNodeKeys.has(nodeKey)) {
      continue;
    }

    reachableNodeKeys.add(nodeKey);

    (outgoingLinks.get(nodeKey) || []).forEach((targetNodeKey) =>
      nodesToVisit.push(targetNodeKey)
    );
  }

  return workflowNodes
    .filter((node) => !reachableNodeKeys.has(node.key))
    .map((node) => node.key);
}
